import { useCallback, useEffect, useState } from 'react';
import privacyPolicy from '../documents/privacy-policy.md';
import termsOfService from '../documents/terms-of-service.md';

const useLegalContent = () => {
  const [showLegalModal, setShowLegalModal] = useState(false);
  const [legalTitle, setLegalTitle] = useState('');
  const [legalContentType, setLegalContentType] = useState('privacy');
  const [privacyContent, setPrivacyContent] = useState('');
  const [termsContent, setTermsContent] = useState('');

  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        const [privacyResponse, termsResponse] = await Promise.all([fetch(privacyPolicy), fetch(termsOfService)]);
        setPrivacyContent(await privacyResponse.text());
        setTermsContent(await termsResponse.text());
      } catch (error) {
        console.error('Error loading legal markdown content:', error);
      }
    };
    loadMarkdown();
  }, []);

  const openLegalModal = useCallback(type => {
    if (type === 'privacy') {
      setLegalTitle('Privacy Policy');
      setLegalContentType('privacy');
    } else {
      setLegalTitle('Terms of Service');
      setLegalContentType('terms');
    }
    setShowLegalModal(true);
  }, []);

  const closeLegalModal = useCallback(() => {
    setShowLegalModal(false);
  }, []);

  return {
    showLegalModal,
    legalTitle,
    legalContentType,
    privacyContent,
    termsContent,
    openLegalModal,
    closeLegalModal,
  };
};

export { useLegalContent };
